<template>
  <div class="input-field" :class="{ 'has-error': error, active: active }">
    <div class="input-field-prepend" v-if="$slots.prepend">
      <slot name="prepend" />
    </div>

    <div class="input-field-inner">
      <label v-if="label" class="input-field-label" :class="{ visible: active || filled }">
        {{ label }}
      </label>
      <div class="input-field-slot-wrapper">
        <slot />
      </div>
    </div>

    <div class="input-field-append" v-if="errorMessage || $slots.append">
      <div v-if="errorMessage" class="error-message">
        {{ errorMessage }}
      </div>
      <slot name="append" />
    </div>
  </div>
</template>

<script setup lang="ts">
defineProps({
  label: {
    type: String,
    default: ''
  },
  active: {
    type: Boolean,
    default: false
  },
  alwaysActive: {
    type: Boolean,
    default: false
  },
  filled: {
    type: Boolean,
    default: false
  },
  required: {
    type: Boolean,
    default: false
  },
  error: {
    type: Boolean,
    default: false
  },
  errorMessage: {
    type: String,
    default: ''
  }
})
</script>

<style lang="scss" scoped>
@import '@/assets/styles/inc/variables';

.input-field {
  position: relative;
  width: 100%;
  margin-bottom: $spacer-3;
}

.input-field-inner {
  position: relative;
  background: transparent;
  border: 2px solid var(--color-border-primary);
  border-radius: $border-radius;
  height: 48px;
  padding: 0 16px;
  display: flex;
  align-items: center;
  transition: $transition-base;

  .input-field.active & {
    border-color: var(--color-border-active);
  }

  .input-field.has-error & {
    border-color: $red50;
  }
}

.input-field-label {
  position: absolute;
  left: $spacer-2;
  top: -$spacer-2;
  background-color: var(--color-bg-primary);
  padding: 0 $spacer-1;
  color: var(--color-text-primary);
  font-family: $font-family-pilat-book;
  font-size: $fs_2;
  font-weight: $font-weight-normal;
  opacity: 0;
  transform: translateY($spacer-1);
  transition:
    opacity 0.2s ease,
    transform 0.2s ease;
  pointer-events: none;
  z-index: 1;

  &.visible {
    opacity: 1;
    transform: translateY(0);
  }
}

.input-field-slot-wrapper {
  display: flex;
  align-items: center;
  width: 100%;
  max-height: 100%;
  overflow: hidden;
}

.input-field-prepend {
  margin-bottom: $spacer-2;
}

.input-field-append {
  margin-top: $spacer-2;
}

.error-message {
  color: $red50;
  font-size: $fs_3;
  margin-top: $spacer-1;
}
</style>
